module.exports = __webpack_public_path__ + "media/images/icons/key-834677598ae3b70a6cfc92c2d468c696.svg";